import { render, staticRenderFns } from "./DiasVencimiento.vue?vue&type=template&id=8e05f87c"
import script from "./DiasVencimiento.vue?vue&type=script&lang=js"
export * from "./DiasVencimiento.vue?vue&type=script&lang=js"
import style0 from "./DiasVencimiento.vue?vue&type=style&index=0&id=8e05f87c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports